export const DEFAULT_IMPACT_DURATION_MINUTES = 60;
export const DEFAULT_RECOVERY_DURATION_MINUTES = 180;
export const CURVE_SAMPLE_COUNT = 260;
const CURVE_DENOMINATOR_EPSILON = 1e-6;

export function piecewiseTau(
  x: number,
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  x3: number,
  y3: number,
  tauRise: number,
  tauFall: number,
): number {
  const riseShape = -tauRise * (1 + Math.abs(tauRise));
  const fallShape = -tauFall * (1 + Math.abs(tauFall));
  if (x < x2) {
    const ratio = Math.max((x - x1) / Math.max(x2 - x1, CURVE_DENOMINATOR_EPSILON), 0);
    return riseShape >= 0
      ? y1 + (y2 - y1) * ratio ** (riseShape + 1)
      : y1 + (y2 - y1) * (1 - (1 - ratio) ** (-riseShape + 1));
  }
  const ratio = Math.min(Math.max((x - x2) / Math.max(x3 - x2, CURVE_DENOMINATOR_EPSILON), 0), 1);
  return fallShape >= 0
    ? y2 + (y3 - y2) * (1 - (1 - ratio) ** (fallShape + 1))
    : y2 + (y3 - y2) * ratio ** (-fallShape + 1);
}
